export const DASHBOARD = "/";
export const COMMUNITY = "/community";
export const EVENTS = "/events";
export const CLUBS = "/clubs";
export const TERMSANDCONDITIONS = "/terms-and-conditions";
export const PRIVACYPOLICY = "/privacy-policy";
export const JOINNOW = "/join-now";
export const NOT_FOUND = "/not-found"; 
